import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { CUSTOMER_PERMISSIONS } from '../store/constants';

const reducer = (state = initialState[CUSTOMER_PERMISSIONS], action) => {
  switch (action.type) {
    case types.LOAD_CUSTOMER_PERMISSIONS.SUCCESS: {
      const { customerPermissions } = action.payload;
      return {
        ...state,
        ...customerPermissions
      };
    }
    default:
      return state;
  }
};

export default reducer;
